const UTM_SEARCH_PARAMS = [
  "utm_source",
  "utm_id",
  "utm_term",
  "utm_content",
  "utm_channel",
  "utm_adgroup",
  "utm_matchtype",
  "utm_device",
  "utm_campaign",
  "utm_medium",
] as const;

const CLICK_ID_SEARCH_PARAMS = ["gclid", "fbclid", "msclkid", "li_fat_id"] as const;

const ATTRIBUTION_SEARCH_PARAMS = [...CLICK_ID_SEARCH_PARAMS, ...UTM_SEARCH_PARAMS] as const;

const isAttributionSearchParam = (key: string): key is (typeof ATTRIBUTION_SEARCH_PARAMS)[number] =>
  ATTRIBUTION_SEARCH_PARAMS.some(param => param === key);

const hasAttributionSearchParams = (searchParams: URLSearchParams) =>
  ATTRIBUTION_SEARCH_PARAMS.some(key => {
    const value = searchParams.get(key);

    return value !== null && value !== "";
  });

const withAttributionSearchParams = (path: string, searchParams: URLSearchParams): string => {
  const attribution = new URLSearchParams();

  searchParams.forEach((value, key) => {
    if (isAttributionSearchParam(key) && value !== "") {
      attribution.append(key, value);
    }
  });

  const serialized = attribution.toString().replaceAll("%2C", ",");
  if (serialized === "") {
    return path;
  }

  return path.includes("?") ? `${path}&${serialized}` : `${path}?${serialized}`;
};

export { ATTRIBUTION_SEARCH_PARAMS, hasAttributionSearchParams, withAttributionSearchParams };
